/**
 * Shared constants used by server and web.
 * Keep this file dependency-free (no Node.js or browser APIs).
 */
/** API version prefix for all HTTP routes. */
export const API_PREFIX = '/api';
/** Default screenshot capture interval (seconds). Lower = smoother but more bandwidth. */
// 2s cadence: smooth near-realtime tiles. Costs ~2.5x more Fly egress
// than 5s — accepted per admin choice (2026-09-23). Raise to 5 if the
// bandwidth line on the invoice ever matters.
export const DEFAULT_SCREENSHOT_INTERVAL_SECONDS = 2;
/** Default agent heartbeat interval (seconds). */
export const DEFAULT_HEARTBEAT_INTERVAL_SECONDS = 30;
/** Consider an agent offline if no heartbeat for this many seconds. */
export const AGENT_OFFLINE_AFTER_SECONDS = 90;
/** Maximum screenshot age to retain on disk. */
export const MAX_SCREENSHOT_AGE_DAYS = 30;
/** Maximum size of a single screenshot upload (bytes). */
export const MAX_SCREENSHOT_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
/** JPEG quality for client-side compression (0-100). */
export const SCREENSHOT_JPEG_QUALITY = 55;
/** Local WebSocket port the Chrome extension connects to on the agent machine. */
export const BROWSER_EXTENSION_WS_PORT = 9876;
/** Socket.IO event names — kept in sync between server emit and client listen. */
export const SOCKET_EVENTS = {
    AGENT_ONLINE: 'agent:online',
    AGENT_OFFLINE: 'agent:offline',
    SCREEN_NEW: 'screen:new',
    ACTIVITY_NEW: 'activity:new',
    DASHBOARD_SUBSCRIBE: 'dashboard:subscribe',
    DASHBOARD_UNSUBSCRIBE: 'dashboard:unsubscribe',
    DASHBOARD_SUBSCRIBE_EMPLOYEE: 'dashboard:subscribe_employee',
    AGENT_COMMAND: 'agent:command',
    AGENT_COMMAND_RESULT: 'agent:command_result',
    AGENT_JOIN: 'agent:join',
    ADMIN_PRESENCE: 'admin:presence',
};
/** Admin role hierarchy (higher = more privileged). */
export const ADMIN_ROLES = {
    VIEWER: 'viewer',
    ADMIN: 'admin',
    SUPER: 'super',
};
/** Agent installation paths (Windows). */
export const AGENT_INSTALL_PATHS = {
    DEFAULT_INSTALL_DIR: 'C:\\Program Files\\EService',
    DEFAULT_LOG_DIR: 'C:\\ProgramData\\EService\\logs',
    TASK_NAME: 'EServiceAgent',
    EXE_NAME: 'monitor-agent.exe',
};
//# sourceMappingURL=index.js.map